module.exports = __webpack_public_path__ + "img/list-fill-blue.f8c467d3.svg";